import { api_delete, api_get, api_post } from '@lf/api-client/lfApi';

export async function getSavedVideos(setError) {
  return await api_get('/video/saved', null, setError);
}

export async function saveVideo(video, setError) {
  if (!video) {
    return null;
  }

  const snippet = video.snippet || {};
  const videoId = video.id?.videoId || video.videoId || video.video_id;
  if (!videoId) {
    return null;
  }

  return await api_post(
    '/video/saved',
    {
      video_id: videoId,
      channel_id: snippet.channelId || video.channel_id || video.channelId,
      title: snippet.title || video.title,
      channel_title: snippet.channelTitle || video.channel_title || video.channelTitle,
      thumbnail_url:
        snippet.thumbnails?.high?.url ||
        snippet.thumbnails?.medium?.url ||
        snippet.thumbnails?.default?.url ||
        video.thumbnail_url ||
        video.thumbnailUrl ||
        '',
    },
    setError,
  );
}

export async function unsaveVideo(videoId, setError) {
  if (!videoId) {
    return null;
  }

  return await api_delete('/video/saved', { video_id: videoId }, setError);
}
